import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    changeLanguageContainer: {
      marginRight: 8,
      alignItems: 'center',
    },

    languageButton: {
      color: palette.blue,
      cursor: 'pointer',
    },
    languageButtonInsideTemplate: {
      color: palette.white,
    },
    languageList: { padding: 0 },
    languageItem: {
      '& .MuiTypography-root': {
        color: palette.gray,
        fontSize: 14,
      },
      borderBottom: `1px solid #eeeeee`,
    },
    selectedLanguage: {
      '& .MuiTypography-root': {
        fontWeight: 'bold',
        color: palette.blue,
      },
    },
  });
